module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lesson-header"
  }, [_c('div', {
    staticClass: "backarrowDiv",
    on: {
      "click": _vm.prevChapter
    }
  }, [_c('inline-svg', {
    staticClass: "arrow-svg-lesson",
    attrs: {
      "src": _vm.arrowIconPath.arrowIconPrevious
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "lesson-titles"
  }, [(_vm.currentData) ? _c('h2', [_vm._v("\n      " + _vm._s(_vm.currentData.courseName) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.currentData) ? _c('h6', [_vm._v("\n      " + _vm._s(_vm.lessonName ? _vm.lessonName : "") + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.outerData) ? _c('h6', [_vm._v("\n      " + _vm._s(_vm.outerData ? _vm.outerData : "") + "\n    ")]) : _vm._e()]), _vm._v(" "), _c('inline-svg', {
    staticClass: "cup-svg",
    class: {
      noShow: _vm.outerData
    },
    attrs: {
      "src": require('../../assets/svg/lesson.svg').default
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-486302e7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Lesson/lesson-header.vue
// module id = 291
// module chunks = 0 1 7 8